import React from "react"
import { Box, Switch, Typography } from "@mui/material"
import { AppWebSupplierGroupsAutocomplete } from "@components/Autocomplete"
import useAutoEuropeDataInfo from "Pages/AutoEuropeTool/Page/@hooks/useDataInfo"
import { autoEuropeDrawerData, autoEuropeOriginalData } from "Pages/AutoEuropeTool/Page/@signals"
import { enrichFilterIds } from "Pages/AutoEuropeTool/Page/@utils/filterEnrich"

export default function AutoEuropeExcludeWebSuppliers() {
	const d = autoEuropeDrawerData.peek()
	const { dataInfo: idsInfo, setDataInfo: setIds } = useAutoEuropeDataInfo(d.filterGroupWebSuppliers ?? [])
	const { dataInfo: exclInfo, setDataInfo: setExcl } = useAutoEuropeDataInfo(d.filterGroupWebSuppliersExclusion ?? false)

	const isExclusion = exclInfo.value
	const ids = idsInfo.value ?? []

	const updateMode = (checked) => setExcl(checked, 'filterGroupWebSuppliersExclusion')
	const updateIds = (_, opts) => setIds(opts ?? [], 'filterGroupWebSuppliers')

	return (
		<Box>
			<Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
				<Switch checked={isExclusion} onChange={e => updateMode(e.target.checked)} size="small"/>
				<Typography variant="body2" sx={{ fontWeight: 500 }}>
					{isExclusion ? 'Exclude web supplier groups' : 'Include web supplier groups'}
				</Typography>
			</Box>
			<AppWebSupplierGroupsAutocomplete
				label={isExclusion ? 'Exclude Web Supplier Groups' : 'Include Web Supplier Groups'}
				placeholder={isExclusion ? 'No groups excluded' : 'No groups included'}
				value={ids.map(o => o?.value ?? o)}
				onChange={updateIds}
				onAjax={options => { enrichFilterIds('filterGroupWebSuppliers', options, autoEuropeDrawerData, autoEuropeOriginalData); return options }}
			/>
		</Box>
	)
}